import React from 'react';

const LabHeader = () => {
    return (
        <div className='headerContainer'>
            <h1>Лабораторная №1</h1>
            <h2>Команда: Фурина В.Д., Жегалин М.А., Шуканова Е.А.</h2>
        </div>
    );
};

export default LabHeader;